import api from './api';
import { KYCDocument } from '../types';

export interface CreateKYCDocumentData {
  customer_id: number;
  document_type: string;
  status?: 'pending' | 'approved' | 'rejected';
  file: File;
}

export interface UpdateKYCDocumentData {
  document_type?: string;
  status?: 'pending' | 'approved' | 'rejected';
}

export interface KYCDocumentFilters {
  customer_id?: number;
  status?: 'pending' | 'approved' | 'rejected';
  document_type?: string;
}

export const kycService = {
  getAll: async (filters?: KYCDocumentFilters): Promise<KYCDocument[]> => {
    const response = await api.get('/api/kyc-documents', { params: filters });
    return response.data;
  },

  getByCustomer: async (customerId: number): Promise<KYCDocument[]> => {
    const response = await api.get(`/api/kyc-documents/customer/${customerId}`);
    return response.data;
  },

  getById: async (id: number): Promise<KYCDocument> => {
    const response = await api.get(`/api/kyc-documents/${id}`);
    return response.data;
  },

  upload: async (data: CreateKYCDocumentData): Promise<KYCDocument> => {
    const formData = new FormData();
    formData.append('file', data.file);
    formData.append('customer_id', data.customer_id.toString());
    formData.append('document_type', data.document_type);
    if (data.status) {
      formData.append('status', data.status);
    }

    const response = await api.post('/api/kyc-documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  update: async (id: number, data: UpdateKYCDocumentData): Promise<void> => {
    await api.put(`/api/kyc-documents/${id}`, data);
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/kyc-documents/${id}`);
  },

  download: async (id: number): Promise<Blob> => {
    const response = await api.get(`/api/kyc-documents/${id}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },

  view: async (id: number): Promise<void> => {
    try {
      const response = await api.get(`/api/kyc-documents/${id}/view`, {
        responseType: 'blob',
      });
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      // Clean up the object URL after a delay
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
      throw error;
    }
  },
};

